'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_sign_SignView$$anon$15() {
  this.bX0 = null;
  this.bWY = null;
  this.bWZ = false;
  this.bWW = null;
  this.bWX = false;
  this.bX1 = false;
  this.bX2 = false;
  this.bX0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_sign_SignView$$anon$15 as $c_Lpresto_pages_sign_SignView$$anon$15 };
$p = $c_Lpresto_pages_sign_SignView$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_sign_SignView$$anon$15;
/** @constructor */
function $h_Lpresto_pages_sign_SignView$$anon$15() {
}
export { $h_Lpresto_pages_sign_SignView$$anon$15 as $h_Lpresto_pages_sign_SignView$$anon$15 };
$h_Lpresto_pages_sign_SignView$$anon$15.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bX0;
});
$p.t = (function() {
  if ((!this.bWZ)) {
    this.bWY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("latitude", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("longitude", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bWZ = true;
  }
  return this.bWY;
});
$p.ag = (function() {
  if ((!this.bWX)) {
    this.bWW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mH, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().mH, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bWX = true;
  }
  return this.bWW;
});
$p.v = (function() {
  if ((!this.bX2)) {
    this.bX1 = false;
    this.bX2 = true;
  }
  return this.bX1;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_sign_SignView$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_sign_SignView$$anon$15, "presto.pages.sign.SignView$$anon$15", ({
  X8: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_sign_SignView$$anon$15 as $d_Lpresto_pages_sign_SignView$$anon$15 };
//# sourceMappingURL=presto.pages.sign.-Sign-View$$anon$15.js.map
